const urlParams = new URLSearchParams(window.location.search);
const searchTerm = urlParams.get('search');
      

$g.load({
    template: { id: "search", target: ".graphene-search" },
    page_context: { search_text: searchTerm },    
    success: function (response) {
      console.log('search loaded');
      document.dispatchEvent(miscProdItemLoaded);
      document.querySelectorAll('.graphene-search .filter-group__label').forEach(filterBtn => {
        filterBtn.addEventListener('click', (e) => {
          let container = filterBtn.parentElement;
          let parentContainer = container.parentElement;

          if (container.querySelector('.filter-group--show-values')) {
            container.querySelector('.filter-group--show-values').setAttribute('aria-hidden', 'true');
            container.querySelector('.filter-group--show-values').classList.toggle('filter-group--active');
            container.querySelector('.filter-group--show-values').classList.toggle('filter-group--show-values');          
          } else {
            if (parentContainer.querySelector('.filter-group--show-values')) {
              parentContainer.querySelector('.filter-group--show-values').setAttribute('aria-hidden', 'true');
              parentContainer.querySelector('.filter-group--show-values').classList.toggle('filter-group--active');
              parentContainer.querySelector('.filter-group--show-values').classList.toggle('filter-group--show-values');
            }
            container.querySelector('.filter-group__values').setAttribute('aria-hidden', 'false');
            container.querySelector('.filter-group__values').classList.toggle('filter-group--active');
            container.querySelector('.filter-group__values').classList.toggle('filter-group--show-values');
          }        
        })
      })
      document.querySelectorAll('.graphene-search .filter-bar__button--filters').forEach(filterBtn => {
        filterBtn.addEventListener('click', (e) => {
          filterBtn.parentElement.parentElement.querySelector('.filter-bar__filters-inner').classList.toggle('hide-choices');
        })
      })
      document.querySelectorAll('.graphene-search .mobile-filters__button').forEach(filterBtn => {
        filterBtn.addEventListener('click', (e) => {
          let target = filterBtn.getAttribute('data-filter-drawer-target');
          

          let filterPopoverContainer = document.querySelector('.graphene-search .filter-drawer.popover.mobile-filter-pane');
          let filterPane = document.querySelector(`.graphene-search .filter-drawer__panel[data-filter-modal=${target}]`);

          filterPopoverContainer.classList.add('is-fixed');
          filterPane.classList.add('animation--filter-bar-revealed');
          filterPane.classList.add('active');

          

        })
      });

      document.querySelectorAll('.graphene-search .filter-drawer__close').forEach(filterBtn => {
        filterBtn.addEventListener('click', (e) => {
          document.querySelector('.graphene-search .filter-drawer.popover.mobile-filter-pane').classList.remove('is-fixed');
          document.querySelector(`.graphene-search .filter-drawer__panel.active`).classList.remove('animation--filter-bar-revealed');
          document.querySelector(`.graphene-search .filter-drawer__panel.active`).classList.remove('active');        
        })
      });

      document.querySelectorAll('.graphene-search .filter-drawer__group-toggle').forEach(filterBtn => {
        filterBtn.addEventListener('click', (e) => {
          let isHidden = filterBtn.nextElementSibling.getAttribute('aria-hidden');
          console.log('isHidden ', isHidden, filterBtn.nextElementSibling);
          if (isHidden == 'true') {
            filterBtn.nextElementSibling.setAttribute('aria-hidden', 'false');    
          } else {
            filterBtn.nextElementSibling.setAttribute('aria-hidden', 'true');
          }
        })
      }); 
      
      document.querySelectorAll('.graphene-search .filter-bar__button--sort').forEach(filterBtn => {
        filterBtn.addEventListener('click', (e) => {
          let isHidden = document.querySelector('.graphene-search #filter-bar-sort').getAttribute('aria-hidden');
          console.log('isHidden ', isHidden);
          if (isHidden == 'true') {
            document.querySelector('.graphene-search #filter-bar-sort').setAttribute('aria-hidden', 'false');    
          } else {
            document.querySelector('.graphene-search #filter-bar-sort').setAttribute('aria-hidden', 'true');
          }
        })
      });  

      document.querySelectorAll('.graphene-search .filter-bar__button--sort').forEach(filterBtn => {
        filterBtn.addEventListener('click', (e) => {
          let isOpen = document.querySelector('.graphene-search #filter-bar-sort').classList.contains('show-sort');
          if (isOpen) {
            document.querySelector('.graphene-search #filter-bar-sort').setAttribute('aria-hidden', 'true');
            document.querySelector('.graphene-search #filter-bar-sort').classList.remove('show-sort');
          } else {
            document.querySelector('.graphene-search #filter-bar-sort').setAttribute('aria-hidden', 'false');
            document.querySelector('.graphene-search #filter-bar-sort').classList.add('show-sort');
            
          }
        })
      });    

      var grapheneReccSlider = new Swiper('.graphene-search--reccs .recommended-products__content', {
        slidesPerView: 4,
        spaceBetween: 20,
        navigation: {
          nextEl: '.models-button-next',
          prevEl: '.models-button-prev'
        },
        breakpoints: {
          280: {
            slidesPerView: 1
          },
          560: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3
          },
          1000: {
            slidesPerView: 4
          },
        }
      });
    }
});


